import { useTranslation } from 'react-i18next';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { clsx } from 'clsx';
import { VALUE_CHAIN_UNIT_TYPES } from 'constants/interfaces';

import renderUnitIcon from '../utils/renderUnitIcon';

import type IUnitLinkChips from '../interfaces/IUnitLinkChips';

import styles from '../scss/UnitLinkField.module.scss';

function UnitLinkChips({
  items, onRemove, isRemoveDisabled, hideRemove,
}: IUnitLinkChips) {
  const { t } = useTranslation();

  if (!items.length) {
    return null;
  }

  return (
    <div className={styles.chips}>
      {items.map((item) => (
        <span
          key={item.itemKey}
          className={clsx(
            styles.chip,
            item.type === VALUE_CHAIN_UNIT_TYPES.BALANCE_SHEET_ASSET
              ? styles.chipBalanceSheetAsset
              : styles.chipSupplier,
          )}
        >
          <span className={styles.chipIcon} aria-hidden="true">
            {renderUnitIcon(item.type)}
          </span>
          <span className={styles.chipLabel}>{item.name}</span>
          {hideRemove ? null : (
            <button
              type="button"
              className={clsx(styles.chipRemoveButton, {
                [styles.chipRemoveButtonBlocked]: isRemoveDisabled,
              })}
              onClick={() => onRemove?.(item.itemKey)}
              aria-label={`${t('common.delete')} ${item.name}`}
              aria-disabled={isRemoveDisabled}
            >
              <CloseIcon />
            </button>
          )}
        </span>
      ))}
    </div>
  );
}

export default UnitLinkChips;
